export interface SpinState {
  blocked: boolean;
}

export interface SpinAction {
  type: string;
}

export const initialState: SpinState = {
  blocked: false,
};

export const spinActions = {
  BLOCK: "BLOCK",
  UNBLOCK: "UNBLOCK",
};

export const reducer = (state: SpinState, action: SpinAction): SpinState => {
  switch (action.type) {
    case spinActions.BLOCK:
      return { blocked: true };
    case spinActions.UNBLOCK:
      return { blocked: false };
    default:
      return state;
  }
};
